/**
 * Created by shubham on 11/4/18.
 */

/**
 * A model for an individual corporate employee
 */
export class PartnersDashboardList {
    id:number;
    Name: string;
    roleName: string;
    email: string;
    emailVerified: boolean;
    userId_WPASS: string;
    languageId: string;
    languageName: string;
    ownerId: string;
    sessionUserManager: boolean;
    status: string;
    createdAt: string;

    constructor(id:number, Name:string, roleName:string, email:string, emailVerified:boolean, userId_WPASS:string, languageId:string,
                languageName: string, ownerId: string, sessionUserManager:boolean, status: string, createdAt: string){
        this.id = id;
        this.Name = Name;
        this.roleName = roleName;
        this.email = email;
        this.emailVerified = emailVerified;
        this.userId_WPASS = userId_WPASS;
        this.languageId = languageId;
        this.languageName = languageName;
        this.ownerId = ownerId;
        this.sessionUserManager = sessionUserManager;
        this.status = status;
        this.createdAt = createdAt;
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/partners-dashboard/partners-datatable/partnersDashboardList.ts